import styled from 'styled-components';

export const TableWrapper = styled.div`
    padding: 0.5rem;
`;